<template>
	<div>


		<div class="lc_bgi">
			<div class="title">
				园区基本信息
			</div>
			<div class="con">
				<div>
					<div class="con1">总面积</div>
					<div class="con2">{{msg.total_area}}</div>
				</div>
				<div>
					<div class="con1">育苗大棚</div>
					<div class="con2">{{msg.nursery_greenhouse}}</div>
				</div>
				<div>
					<div class="con1">种植大棚</div>
					<div class="con2">{{msg.planting_greenhouse}}</div>
				</div>
				<div>
					<div class="con1">玻璃温室</div>
					<div class="con2">{{msg.glass_greenhouse}}</div>
				</div>
				<div style="width: 100%;">
					<div class="con1">种植作物</div>
					<div class="con2">{{msg.grow_crops}}</div>
				</div>
			</div>
		</div>




	</div>
</template>

<script>
	import {
		park_information
	} from "../../api/home.js";
	import {
		Message
	} from 'element-ui';
	export default {

		data() {
			return {
				msg: {}
			}
		},
		mounted() {
			this.get()
		},
		methods: {
			get() {
				park_information().then((res) => {

					if (res.code == 0) {
						this.msg = res.data
						console.log(this.msg)
					} else {
						Message.error(res.msg)

					}

				})
			}
		}
	}
</script>

<style scoped lang="less">
	.lc_bgi {
		width: 28vw;
		height: 31vh;
		background-image: url(/src/assets/lc.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		position: relative;

	}

	.title {

		font-family: Source Han Sans CN;
		font-weight: bolder;
		font-size: 18px;
		color: #FFFFFF;
		font-style: italic;
		background: linear-gradient(0deg, #B5FFDA 0%, #FFFFFF 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		position: absolute;
		left: 70px;
		top: 12px

	}

	.con {
		width: 88%;

		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		position: absolute;
		top: 65px;
		left: 40px;

		// background-color: #fff;
	}

	.con>div {
		width: 44%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 60px;
		margin-top: 6px;
		background-image: url(/src/assets/lcs.png);
		border-radius: 2px;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		// margin-left: 20px;
		padding-left: 10px;
		padding-right: 10px;
	}

	.con1 {
		font-family: Source Han Sans CN;
		font-weight: 500;
		font-size: 16px;
		color: #FFFFFF;


	}

	.con2 {
		font-family: PangMenZhengDao;
		font-weight: bold;
		font-size: 18px;
		color: #11E5C0;

	}
</style>